import styled from 'styled-components';

export const OuterDot = styled.span`
  background-color: var(--base-bg-primary);
  border-radius: var(--border-r-circle);
  height: 12px;
  position: absolute;
  right: 5px;
  top: 4px;
  width: 12px;
`;

export const InnerDot = styled.span`
  background-color: var(--control-text-bad);
  border-radius: var(--border-r-circle);
  height: 8px;
  position: absolute;
  right: 2px;
  top: 2px;
  width: 8px;
`;

export const ListButton = styled.button`
  align-items: center;
  background-color: transparent;
  border-radius: var(--border-r-stamp);
  border: none;
  color: var(--base-text-primary);
  cursor: pointer;
  display: flex;
  font: var(--body-sm-medium);
  height: 32px;
  justify-content: center;
  position: relative;
  width: 32px;

  &:focus-visible {
    outline: var(--border-b-stamp) solid var(--control-border-focus-ring);
  }
  &.active {
    color: var(--control-bg-selected);
  }
  &:hover {
    background: var(--control-bg-decorative-hover);
  }
`;
